import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/faq';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="defer-paint w-full bg-sand py-10 sm:py-14" aria-labelledby="faq-heading" data-id="element-49" data-mp="1bl23p9e8x8f0">
      <div className="mx-auto max-w-3xl px-6" data-id="element-50" data-mp="1gj3lzs3ul3pf">
        <div className="text-center" data-id="element-51" data-mp="1gjvjx9kx3div">
          <p className="eyebrow text-navy" data-id="element-52" data-mp="249g39tkzgcso">❓ Before you decide</p>
          <h2 id="faq-heading" className="mt-4 font-display text-[1.85rem] font-extrabold leading-[1.1] text-ink sm:text-4xl" data-id="element-53" data-mp="249zjn5uzit4l">
            Frequently asked questions
          </h2>
        </div>

        <ul className="mt-9 space-y-2.5" data-id="element-54" data-mp="1uj4otd3oal7j">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} className={`rounded-3xl border bg-shell transition-colors duration-150 ease-out ${isOpen ? 'border-navy/40' : 'border-line'}`} data-id="element-55" data-mp="2n822t40upvuh" data-mpi={index}>
                <h3 data-id="element-56" data-mp="2s03eanq73ijg">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 rounded-3xl px-6 py-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-navy" data-id="element-57" data-mp="2s0lfzzvmmoyr">
                    <span className="font-display text-base font-bold leading-snug text-ink sm:text-lg" data-id="element-58" data-mp="19tc150gnxsma">
                      {faq.question}
                    </span>
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors duration-150 ease-out ${isOpen ? 'bg-navy text-shell' : 'bg-navy-light text-navy'}`} aria-hidden="true" data-id="element-59" data-mp="1jkgfpz2ffbgl">
                      <PlusIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-60" data-mp="1slxxdlvhfl7e" />
                    </span>
                  </button>
                </h3>

                <div id={`faq-panel-${index}`} className={`grid transition-[grid-template-rows,opacity] duration-200 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-61" data-mp="3udaydzubx8y6">
                  <div className="overflow-hidden" data-id="element-62" data-mp="23995rmwlw2no">
                    <p className="px-6 pb-6 font-sans text-[0.93rem] leading-relaxed text-stone" data-id="element-63" data-mp="287akxwqwvhtv">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}